import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params}   from '@angular/router';

import {CloudApiService} from "../../services/cloud-api.service";
import {UserDto} from "../../services/dtos/user.dto";

import 'rxjs/add/operator/switchMap';

enum State {
    None,
    ValidatingToken,
    Ready,
    Processing,
    Success
}

@Component({
    selector: 'app-password-reset',
    template: require('./password-reset.component.html'),
    styles: [ require('./password-reset.component.css') ]
})
export class PasswordResetComponent implements OnInit {

    states = State;
    state: State = State.None;
    errorMessage: string;

    token: string;
    user: UserDto;
    password: string;
    passwordConfirm: string;

    constructor(
        private route: ActivatedRoute,
        private cloudApiService: CloudApiService,
    ) {}

    ngOnInit(): void {
        this.validateToken();
    }

    onSubmit(): void {
        this.resetPassword();
    }

    private validateToken(): void {
        this.state = State.ValidatingToken;

        this.route.params
            .switchMap((params: Params) => {
                this.token = params['token'];
                return this.cloudApiService.getUserByPasswordResetToken(this.token);
            })
            .subscribe(
                user => {
                    this.user = user;
                    this.state = State.Ready;
                },
                error => {
                    this.errorMessage = error;
                    this.state = State.None;
                }
            );
    }

    private resetPassword(): void {
        if (this.password != this.passwordConfirm) {
            this.errorMessage = 'Supplied passwords do not match.';
            return;
        }

        this.errorMessage = null;
        this.state = State.Processing;

        this.cloudApiService.resetUserPassword(this.token, this.password)
            .finally(() => {
                this.password = '';
                this.passwordConfirm = '';
            })
            .subscribe(
                () => this.state = State.Success,
                error => {
                    this.errorMessage = error;
                    this.state = State.Ready;
                }
            )
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/components/password-reset/password-reset.component.ts